import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'subpage.mindfulness.hero.heading',
		defaultMessage:
			'Mindfulness, meditation and guided programs to build healthy habits that will last a lifetime',
		description: 'Heading for the mindfulness category page hero',
	},
	body: {
		id: 'subpage.mindfulness.hero.body',
		defaultMessage:
			"You're in the right place. Calm puts the tools to achieve mindfulness in your back pocket with guided meditations, soothing music, and daily guided programs designed to fit into your lifestyle in practical ways.",
		description: 'Body text for the mindfulness category page hero',
	},
	cta: {
		id: 'subpage.mindfulness.hero.cta',
		defaultMessage: 'Live mindfully for free',
		description: 'Button text for the mindfulness category page hero',
	},
});
